import { create } from 'zustand'

export const useLogStore = create((set) => ({
  logs: [],
  addLog: (type, message, details = null) => set((state) => {
    const newLog = {
      id: Date.now() + Math.random().toString(36).substr(2, 5),
      timestamp: new Date().toISOString(),
      type, // 'error', 'info', 'warn'
      message,
      details,
    }
    // Keep only last 100 logs
    const nextLogs = [newLog, ...state.logs].slice(0, 100)
    return { logs: nextLogs }
  }),
  clearLogs: () => set({ logs: [] })
}))

// Intercepter console.error globalement pour capturer les erreurs non gérées
const originalError = console.error
console.error = (...args) => {
  // Ignorer certains warnings React bénins si besoin, mais on capture le reste
  const msg = args.map(a => {
    try {
      return typeof a === 'object' ? JSON.stringify(a) : String(a)
    } catch { return 'Unserializable object' }
  }).join(' ')
  
  // Ne pas créer de boucle infinie
  if (!msg.includes('Zustand')) { 
    useLogStore.getState().addLog('error', 'Console Error', msg)
  }
  
  originalError.apply(console, args)
}
